module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-blue@3x-31621494.svg";